import React, { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  ButtonGroup,
  Dropdown,
  Modal,
  Form,
  Table,
  Nav,
  Tab,
  Tabs,
  Card,
  Breadcrumb,
  FormCheck
} from "react-bootstrap";

import { auth } from "../config/Config";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";

export default function AddQuotation() {
  const isDraftItem = (item) => {
    if (!item) return false;
    return !!(
      item.isDraft === true ||
      item.draftTag === 'Draft Saved Copy' ||
      item.isDraftCopy === true ||
      (item.ID && String(item.ID).startsWith('draft_')) ||
      (item.id && String(item.id).startsWith('draft_')) ||
      (item.roomTypeDesign && String(item.roomTypeDesign).toLowerCase().includes('draft'))
    );
  };

  const handleCheckboxClick = (e, l) => {
    if (isDraftItem(l)) {
      e.preventDefault();
      Swal.fire({
        icon: 'error',
        title: 'Unsaved Draft Item',
        text: 'This design option is an unsaved draft. Please open it in Edit Rooms, verify all items, and click Save before including it in a quotation.',
        confirmButtonColor: '#e85d13',
      });
      return false;
    }
  };

  const userDetailsLocal = localStorage.getItem('userDetails');
  const userDetailsLo = JSON.parse(userDetailsLocal);

  const navigation = useNavigate();
  const location = useLocation();
  const data = location.state;
  const dispatch = useDispatch();

  const [value, setValue] = useState([]);
  const [sta, setSta] = useState(false);
  const [inputTitle, setInputTitle] = useState('');
  const [inputBase, setInputBase] = useState(0);
  const [inputDiscount, setInputDiscount] = useState(0);
  const [InputTaxation, setInputTaxation] = useState(0);
  const [loading, setLoading] = useState(false);

  // ─── Rule: based on project creation date ────────────────────────────────
  // Projects created on or after April 7, 2026 → GST fixed at 18, discount max 25
  // Projects created before April 7, 2026      → GST and discount are free
  const savedTime = localStorage.getItem('projectCreationTime');       // ISO string saved earlier
  const projectDate = savedTime ? new Date(savedTime) : null;          // convert back to Date
  const ruleStartDate = new Date('2026-04-07T00:00:00');               // April 7, 2026
  const isNewRuleActive = projectDate ? projectDate >= ruleStartDate : false;

  console.log('projectDate:', projectDate);
  console.log('isNewRuleActive:', isNewRuleActive);
  // ──────────────────────────────────────────────────────────────────────────

  // If new rule active, GST is always 18, otherwise use whatever user types
  const effectiveTaxation = isNewRuleActive ? 18 : InputTaxation;

  const { allAssigneRoomData } = useSelector((state) => state.assigneProjectRooms);
  const { viewData } = useSelector((state) => state.viewrooms);
  console.log("allAssigneRoomData", allAssigneRoomData);
  console.log("viewData", viewData);

  useEffect(() => {
      setViewDatas(allAssigneRoomData.assignedRooms);
   
  })

  const [viewDatas, setViewDatas] = useState([]);
  console.log("2st Step", viewDatas);

  const result = viewDatas?.reduce((finalArray, current) => {
    let obj = finalArray.find((item) => item.roomTypeName === current.roomTypeName);
    if (obj) {
      return finalArray;
    }
    return finalArray.concat([current]);
  }, []);

  const handleLogOut = () => {
    auth.signOut();
  }

  const [userinfo, setUserInfo] = useState([{
    languages: [],
    response: [],
  }]);
  const [peopleInfo, setPeopleInfo] = useState([]);
  console.log('peopleInfo', peopleInfo);

  const [calculationWood, setCalculationWood] = useState(0);
  const [calculationAccess, setCalculationAccess] = useState(0);
  const [calculationInfo, setCalculationInfo] = useState(0);
  const [selectedDesigns, setSelectedDesigns] = useState({});
  const [finalPrice, setFinalPrice] = useState(0);

  console.log("selectedDesigns", selectedDesigns);
  console.log("calculationInfo", calculationInfo);
  console.log("calculationWood", calculationWood);
  console.log("finalPrice", finalPrice);
  console.log("inputDiscount, effectiveTaxation", inputDiscount, effectiveTaxation);

  useEffect(() => {
    if (inputDiscount || effectiveTaxation) {
      const afterDiscount = Math.round(calculationInfo - calculationWood * (inputDiscount / 100));
      const totalTaxation = Math.round(afterDiscount * (effectiveTaxation / 100));
      const finalPrice = Math.round(afterDiscount + totalTaxation);
      setFinalPrice(finalPrice);
    } else {
      setFinalPrice(calculationInfo);
    }
  }, [calculationInfo, inputDiscount, effectiveTaxation])


  const handleChange = (e, roomTypeName, roomType) => {
    console.log("e", e);
    console.log("roomTypeName", roomTypeName);
    console.log("roomType", roomType);

    let totalPriceAccessories = 0;
    let totalPriceWood = 0;
    const { id, value, checked } = e.target;
    console.log('checing data for ID', id);
    console.log('checked', checked);
    const { languages } = userinfo;
    let quoteChecked = [];
    console.log(`quoteChecked`, quoteChecked);

    setSelectedDesigns({
      ...selectedDesigns,
      [roomTypeName]: checked ? id : null
    });

    if (checked) {
      peopleInfo.push(id);
      setCalculationInfo(calculationInfo + 1);
    } else {
      for (var i = 0; i < peopleInfo.length; i++) {
        if (peopleInfo[i] === id) {
          peopleInfo.splice(i, 1);
          setCalculationInfo(calculationInfo - 1);
        }
      }
    }

    for (var i = 0; i < peopleInfo.length; i++) {
      for (var j = 0; j < viewDatas.length; j++) {
        if (peopleInfo[i] === viewDatas[j].id || peopleInfo[i] === viewDatas[j].ID) {
          quoteChecked.push(viewDatas[j].roomTypePrice);
          if (
            viewDatas[j].roomType !== "Accessories" ||
            viewDatas[j].roomType !== "Loose Furniture" ||
            viewDatas[j].roomType !== "Other Works" ||
            viewDatas[j].roomType !== "ExtraItems"
          ) {
            totalPriceWood += viewDatas[j].roomTypeWoodPrice;
          }
        }
      }
    }

    console.log('totalPriceWood', totalPriceWood);
    setCalculationWood(totalPriceWood);

    const reducerOfPrice = (accumulator, currentValue) => accumulator + currentValue;
    console.log('reducerOfPrice', reducerOfPrice);
    console.log('quoteChecked', quoteChecked);

    const totalPrice = quoteChecked.reduce(reducerOfPrice, 0);
    console.log('totalPrice', totalPrice);
    setCalculationInfo(totalPrice);
  };


  const quoteDate = new Date().toLocaleDateString();

  const handleFinalQuotation = (e) => {
    e.preventDefault();
    setLoading(true);

    let quotationData = [];
    let quotationWood = 0;

    for (var i = 0; i < peopleInfo.length; i++) {
      for (var j = 0; j < viewDatas.length; j++) {
        if (peopleInfo[i] === viewDatas[j].id || peopleInfo[i] === viewDatas[j].ID) {
          quotationData.push(viewDatas[j]);
          if (
            viewDatas[j].roomType === "Kitchen" ||
            viewDatas[j].roomType === "Bedroom" ||
            viewDatas[j].roomType === "Foyer" ||
            viewDatas[j].roomType === "Living Room"
          ) {
            quotationWood += viewDatas[j].roomTypeWoodPrice;
            setCalculationWood(quotationWood);
          }
        }
      }
    }

    const payload = {
      quotationData,
      clientDetails: data,
      userDetials: [userDetailsLo],
      quotationName: inputTitle,
      quotationpermission: {
        "height": true,
        "width": true,
        "area": true
      },
      quotationBase: inputBase,
      // assignequotation: true,
      quotationDiscount: inputDiscount,
      quotationTaxation: effectiveTaxation,  // 18 if new rule active, else user input
      quotationDate: quoteDate,
      quotationWood: calculationWood,
      quotationPrice: calculationInfo,
      quotiationAssignedStatus: "true",
      timestamp: new Date(),
      userId: data.ID
    };

    fetch(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/project/${data.id}/quotations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(() => {
       
          setLoading(false);
          navigation("/assigned/view-rooms", { state: data });
        
      })
      .catch((error) => console.error('Error:', error));
  }


  // ─── Discount change handler: cap at 25 if new rule active ───────────────
  const handleDiscountChange = (e) => {
    let val = parseFloat(e.target.value) || 0;
    if (isNewRuleActive && val > 25) {
      val = 25;
    }
    setInputDiscount(val);
  };
  // ──────────────────────────────────────────────────────────────────────────


  return (
    <Container fluid>
      <Row className='m-0'>
        <Col sm={1}>
          <Tab.Container>
            <Row>
            </Row>
          </Tab.Container>
        </Col>
        <Col sm={11}>
          <Row className="p-4">
            <Row className="w-auto">
              <Breadcrumb>
                <Breadcrumb.Item style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  color: "#333",
                  textTransform: "uppercase",
                  letterSpacing: "-0.5px",
                  transition: "all 0.3s ease",
                  marginLeft: "10px",
                  textDecoration: "none",
                  backgroundColor: "#FDC771",
                  borderRadius: "0 20px 20px 0",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  height: 30,
                  width: 'auto',
                  paddingRight: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }} href="/assigned">
                  {'Assigne Rooms'}
                </Breadcrumb.Item>

                <Breadcrumb.Item style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  color: "#333",
                  textTransform: "uppercase",
                  letterSpacing: "-0.5px",
                  transition: "all 0.3s ease",
                  marginLeft: "10px",
                  textDecoration: "none",
                  backgroundColor: "#FDC771",
                  borderRadius: "0 20px 20px 0",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  height: 30,
                  width: 'auto',
                  display: "flex",
                  paddingRight: "10px",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }} onClick={() => navigation("/assigned/view-rooms", { state: data })}>
                  {data?.pname}
                </Breadcrumb.Item>

                <Breadcrumb.Item style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  color: "#333",
                  textTransform: "uppercase",
                  letterSpacing: "-0.5px",
                  transition: "all 0.3s ease",
                  marginLeft: "10px",
                  textDecoration: "none",
                  backgroundColor: "#FDC771",
                  borderRadius: "0 20px 20px 0",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  height: 30,
                  width: 'auto',
                  paddingRight: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }} active>Add Quotation</Breadcrumb.Item>
              </Breadcrumb>
            </Row>

            <Form onSubmit={handleFinalQuotation}>
              {result.map((i, ind) => (
                <Row key={i.ID}>
                  <Row className="mt-2">
                    <Col className="md-12">
                      <h2 style={{ fontSize: 20, fontFamily: 'Arial', fontWeight: 150 }}>
                        {i.roomTypeName}
                      </h2>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="table-container">
                        <div className="tableScroll">
                          <table responsive hover>
                            <thead>
                              <tr className="table-warning">
                                <th></th>
                                <th>Design Option</th>
                                <th></th>
                                <th>Components</th>
                                <th>Addtional H/W</th>
                                <th>Total</th>
                              </tr>
                            </thead>
                            <tbody className="table-light">
                              {viewDatas.map((l, index) => l.roomTypeName == i.roomTypeName ? (
                                <tr key={l.ID}>
                                  <td>
                                    <input
                                      value={l.roomTypePrice}
                                      disabled={l.roomTypePrice === 0 || isDraftItem(l)}
                                      style={{
                                        width: '20px',
                                        height: '20px',
                                        cursor: isDraftItem(l) ? 'not-allowed' : 'pointer',
                                        opacity: isDraftItem(l) ? 0.5 : 1
                                      }}
                                      type="checkbox"
                                      id={l.ID}
                                      name={l.ID}
                                      onClick={(e) => handleCheckboxClick(e, l)}
                                      onChange={(e) => handleChange(e, l.roomTypeName, l.roomType)}
                                    />
                                  </td>
                                  <td>
                                    {l.roomTypeDesign}
                                    {isDraftItem(l) && (
                                      <span className="badge bg-warning text-dark ms-2" style={{ fontSize: '10px' }}>
                                        Unsaved Draft (Save in Edit Room first)
                                      </span>
                                    )}
                                  </td>
                                  <td></td>
                                  <td>{'\u20B9'} {l.roomTypePrice}</td>
                                  <td>-</td>
                                  <td>{'\u20B9'} {l.roomTypePrice}</td>
                                </tr>
                              ) : null)}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <hr />
                    </Col>
                  </Row>
                </Row>
              ))}

              <Row className="mt-5">

                {/* Total */}
                <Col className="md-4 p-3 justify-content-center" style={{ backgroundColor: '#a0efff' }}>
                  <h2 style={{ fontSize: 24, fontFamily: 'Arial', fontWeight: 100 }}>
                    Total : ₹ {finalPrice}
                  </h2>
                </Col>

                {/* Taxation — locked to 18 if new rule active */}
                <Col className="md-4 p-3 justify-content-center" style={{ backgroundColor: '#a0efff' }}>
                  <Form.Control
                    type="number"
                    placeholder="Taxation"
                    className="w-75"
                    name='QuotationTaxation'
                    value={isNewRuleActive ? 18 : (InputTaxation || '')}
                    readOnly={isNewRuleActive}
                    onChange={(e) => !isNewRuleActive && setInputTaxation(e.target.value)}
                    style={isNewRuleActive ? { backgroundColor: '#e9ecef', cursor: 'not-allowed' } : {}}
                  />
                  {isNewRuleActive && (
                    <small style={{ color: '#6c757d', fontSize: '11px' }}>GST fixed at 18%</small>
                  )}
                </Col>

                {/* Discount — max 25 if new rule active */}
                <Col className="md-4 p-3 justify-content-center" style={{ backgroundColor: '#a0efff' }}>
                  <Form.Control
                    type="number"
                    placeholder="Discount"
                    className="w-75"
                    name='QuotationDiscount'
                    max={isNewRuleActive ? 25 : undefined}
                    onChange={handleDiscountChange}
                  />
                  {isNewRuleActive && (
                    <small style={{ color: '#6c757d', fontSize: '11px' }}>Max discount: 25%</small>
                  )}
                </Col>

                {/* Title */}
                <Col className="md-4 p-3 justify-content-center" style={{ backgroundColor: '#a0efff' }}>
                  <Form.Control
                    type="text"
                    placeholder="Title (Mandatory)*"
                    className="w-75"
                    name='QuotationTitle'
                    onChange={(e) => setInputTitle(e.target.value)}
                  />
                </Col>

                {/* Submit */}
                <Col className="md-4 p-3 justify-content-center" style={{ backgroundColor: '#a0efff' }}>
                  <Button
                    className="w-75 p-2 rounded-5"
                    style={{ fontSize: 20, fontWeight: 600 }}
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />{" "}
                        Creating...
                      </>
                    ) : (
                      "Create"
                    )}
                  </Button>
                </Col>

              </Row>
            </Form>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}